<template>
  <BaseTableItemAction
    v-can:[deletePermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-delete"
    actionName="حذف"
    @click="openDeleteDialog()"
  >
    <DeleteEthicalAdviceDialog
      :showCondition="showDeleteDialog"
      :item="item"
      @closed="closeDeleteDialog"
    />
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_ETHICAL_ADVICES_PERMISSION } from "@/core/statics/Permissions";
import DeleteEthicalAdviceDialog from "../dialogs/DeleteEthicalAdviceDialog.vue";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      deletePermission: WRITE_ETHICAL_ADVICES_PERMISSION,
      showDeleteDialog: false,
    };
  },
  methods: {
    openDeleteDialog() {
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
  components: { DeleteEthicalAdviceDialog },
};
</script>

<style></style>
